import { render, staticRenderFns } from "./CommonSimple.vue?vue&type=template&id=95cd1d50&"
import script from "./CommonSimple.vue?vue&type=script&lang=js&"
export * from "./CommonSimple.vue?vue&type=script&lang=js&"
import style0 from "./CommonSimple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports